/**
 * Enhanced Breakpoints for Resolution-Based Scaling
 * 
 * Updated to support 4K displays and assembly line environments
 * These breakpoints align with the resolution tiers in resolutionConfig.js
 * 
 * Breakpoint Mapping:
 * xs: 0px       - Mobile (legacy, not primary use case)
 * sm: 1024px    - Small tablets
 * md: 1536px    - Standard laptops
 * lg: 1920px    - Full HD monitors (1920x1080)
 * xl: 2560px    - QHD monitors (2560x1440)
 * xxl: 3200px   - 4K displays (3200x1800)
 * xxxl: 3840px  - Large 4K+ displays (3840x2160) - Assembly line ready
 */

const breakpoints = {
  values: {
    xs: 0,       // Mobile/Small
    sm: 1024,    // Tablets
    md: 1536,    // Laptops (Scale: 1.0x)
    lg: 1920,    // FHD - Full HD (Scale: 1.2x)
    xl: 2560,    // QHD - Quad HD (Scale: 1.5x)
    xxl: 3200,   // 4K Standard (Scale: 2.0x)
    xxxl: 3840,  // 4K+ Assembly Line (Scale: 2.5x)
  },
  // Custom helper to check if breakpoint is 4K or higher
  is4K: (width) => width >= 3200,
  // Custom helper to check if breakpoint is assembly line ready
  isAssemblyLine: (width) => width >= 3840,
};

export default breakpoints;
